import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from '@fiverr-private/fit';
import { CloseIcon } from '@fiverr-private/icons';
import { grey_900 } from '@fiverr-private/sass/helpers';

import classes from './style.module.scss';

export const CloseModalButton = ({ close, className }) => (
    <Button className={classNames(classes.closeButton, className)}
        onClick={close} color={Button.COLORS.WHITE}
        data-testid="close_modal_button">
        <CloseIcon color={grey_900}/>
    </Button>
);

CloseModalButton.propTypes = {
    close: PropTypes.func.isRequired,
    className: PropTypes.string
};
